import {  useState } from "react"
import { useDispatch, useSelector } from 'react-redux';
import { IoMdClose } from "react-icons/io";
import LoginService from "../../../services/login";
import { motion } from "framer-motion";


const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export default function PhoneStep({phone ,setPhone,onNext}){
   
    const [loading,setLoading]=useState(false)
    const [error, setError] = useState(""); 
    const [loadingBtn,setLoadingBtn]=useState(false)
    
//   async  function onNextBtnClick(){
//         setLoading(true)
//         let phNum="";
//         for(let i=0 ; i<phone.length ;i++){
//             if(phone[i]!==" "){
//                 phNum+=phone[i]
//             }
//         }

        
//         try{
//             const body={
//                 "mobile":phNum
//             }
//             const res=await LoginService.sendOtp(body)
          
//             if(res?.status==200){
             

//                 dispatch(showToast({ message: res?.data?.meassage, type: "success" }));
//                     onNext()
//                     setLoading(false)
           

//             }
        
//         }catch(err){
//             console.log(err)
        
//             setLoading(false)
//             dispatch(showToast({ message: err?.data?.message, type: "error" }));
      
//         }
//     }

        function formatNumber(input) {
              const digits = input.replace(/\D/g, "").slice(0, 11); // فقط عدد، حداکثر 11 رقم

              let formatted = "";
              if (digits.length <= 4) {
                formatted = digits;
              } else if (digits.length <= 7) {
                formatted = digits.slice(0, 4) + " " + digits.slice(4);
              } else {
                formatted =
                  digits.slice(0, 4) + " " + digits.slice(4, 7) + " " + digits.slice(7);
              }

              return formatted;
        }

        function handleChange(e) {
          const input = e.target.value;

          if (/^[0-9 ]*$/.test(input)) {
            setPhone(formatNumber(input));
          }
        }

        function prepareForApi(input) {

          let digits = input.replace(/\D/g, "");
        
   
          if (digits.startsWith("0")) {
            digits = digits.slice(1);
          }
        
          return digits; 
        }

   async function handleSendPhoneNumberToDb(){
    setLoadingBtn(true)
      try{

        const num=prepareForApi(phone)
        const body={
            "mobile":num
        }
        const res=await LoginService.sentOtp(body)
      
        if (res.status==200){
          alert(res?.data?.data)
          onNext()
        }
        if (res.status!=200){
          setError(res.data?.message)
        }
        setLoadingBtn(false)

      }catch(err){
 
        setLoadingBtn(false)
        setError(err?.data?.data?.message ||err?.data?.message )
      }

    }
    
    return(
        <>  
        <div className="w-full min-h-screen flex flex-col  items-center  justify-center px-5 lg:px-10 overflow-x-hidden">



         

            <motion.div
            variants={fadeUp}
            initial="hidden"
            animate="show"
             className="flex flex-col justify-center items-start text-start md:w-[400px] w-full gap-5">
                
                <div className="flex flex-row justify-center w-full h-max">
                  <img className="w-[80px] object-contain" src="./icon-512.png"></img>
                </div>


              <div className="flex flex-col  justify-center">

                 <div className="flex  flex-row gap-1 items-center justify-start text-[20px] text-gray-600">
                      <p className="inline ">ورود |</p>
                      <p className="inline">ثبت نام</p>
                  </div>
                  <p className="lg:text-[17px] text-[15px]  text-gray-400 mt-4">لطفا شماره موبایل خود را وارد کنید</p>

              </div>


                <fieldset  className={`h-max relative w-full rounded-[15px] mt-6 p-2.5 box-border ${
                      error ? "border-2 border-red-500 animate-shake" : "border-2 border-gray-400"
                    }`}>
            
                    <legend    className={`px-2 text-sm bg-white rtl:ml-3 ltr:ml-3 lg:text-[17px] text-[13px] ${
                      error ? "text-red-500" : "text-[#112C85]"
                    }`}>
                      شماره موبایل
                    </legend>

                    {/* Input */}
                    <input
                    dir="ltr"
                    value={phone}
                    onChange={handleChange}
                      type="text"
                      placeholder="مثال: 0912..."
                      className="w-full h-[22px] text-right lg:text-[17px] text-[13px] border-none outline-none px-4 bg-transparent text-base"
                    />
                            <button onClick={()=>{setPhone("")}} className="w-4 h-4 bg-text-secondary rounded-full absolute left-6 text-center  items-center">
                              <div className="w-full h-full flex flex-row justify-center items-center">
                                  <IoMdClose size={12} className="text-white text-center"></IoMdClose>
                              </div>

                            </button>
                </fieldset>
                {error && (
                    <p className="text-red-500 text-sm mt-1 px-1">
                      {error}
                    </p>
                  )}

                <button onClick={handleSendPhoneNumberToDb} className={`md:w-[400px] w-full h-[60px] bg-special ${loadingBtn ? "bg-opacity-70" : "bg-opacity-100"}  flex flex-row justify-center items-center text-white rounded-xl`}>
                  <p className="text-[20px]">{loadingBtn ? "منتظر بمانید ..." : "ورود"}</p>
                </button>
{/* 
                <div className="flex items-center w-full gap-2 mt-4">
                    <input type="checkbox" className="flex-shrink-0" />
                    <p className="lg:text-[15px] text-[12px] text-secondary flex flex-wrap gap-[4px]">
                      با ثبت نام در بارسرا،  
                      <span className="text-primary">شرایط و قوانین</span> و 
                      <span className="text-primary">بیانیه حریم خصوصی</span> را قبول می‌کنم
                    </p>
                </div> */}

            </motion.div>
        </div>



        </>
    )
}